import "./TimeLineCard.scss";

const TimeLineCard = ({ imageMap, imageUrl, altText, year, description }) => {

  return (
    <div className="timelineCardContainer">
      <div className="timelineImgParent">
        {imageMap[imageUrl] ? (
          <img src={imageMap[imageUrl]} alt={altText} />
        ) : (
          <p style={{ color: "red" }}>Image not found</p> 
        )}
      </div>
      <div>
        <h3 style={{ color: "white", margin: "10px 0" }} className="timeline-year">{year}</h3>
      </div>
      <div className="timeline-description">
        <p>{description}</p>
      </div>
    </div>
  )
}

export default TimeLineCard
